import instance from "./BasebAtreemoApi";

export function validateAtreemoCredentials(data) {
  return instance.request({
    url: `validate-credentials/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function saveAtreemoMappings(data) {
  return instance.request({
    url: `save-mappings/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getAtreemoStatus(organisationId, locationId = null, brandId = null) {
  return instance.request({
    url: `status/?organisation_id=${organisationId}${locationId ? `&location_id=${locationId}` : ''}${brandId ? `&brand_id=${brandId}` : ''}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getAtreemoResources(organisationId) {
  return instance.request({
    url: `resources/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getAtreemoMappings(organisationId) {
  return instance.request({
    url: `mappings/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deactivateAtreemo(data) {
  return instance.request({
    url: `deactivate/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
